import axios from "axios";
import * as actions from "./actionsTypes";
import messages from "../../messages";
import toastr from "toastr";
import UnlinkTemplatesServices from "./unlink_templates.services";

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const getUnlinkTemplates = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_UNLINK_TEMPLATES,
      payload: true,
    });
    const resp = await UnlinkTemplatesServices.getUnlinkTemplates(filters);
    dispatch({
      type: actions.GET_UNLINK_TEMPLATES,
      payload: {
        unlinkTemplates: resp.data.data,
        unlinkTemplatesLength: resp.data.count,
      },
    });
    dispatch({
      type: actions.UNLINK_TEMPLATES_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.UNLINK_TEMPLATES_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_UNLINK_TEMPLATES,
      payload: false,
    });
  }
};

export const saveUnlinkTemplates = (data) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADING_UNLINK_TEMPLATES,
      payload: true,
    });
    const resp = await UnlinkTemplatesServices.saveUnlinkTemplates(data);
    const { unlinkTemplates, unlinkTemplatesLength } = getState().unlinkTemplates;
    const aUnlinkTemplates = [...unlinkTemplates, resp.data];
    dispatch({
      type: actions.GET_UNLINK_TEMPLATES,
      payload: {
        unlinkTemplates: aUnlinkTemplates,
        unlinkTemplatesLength: unlinkTemplatesLength + 1,
      },
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORM_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.SAVE_LOADING_UNLINK_TEMPLATES,
      payload: false,
    });
  }
};

export const editUnlinkTemplates = (data, id, index) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_UNLINK_TEMPLATES,
      payload: true,
    });
    const resp = await UnlinkTemplatesServices.editUnlinkTemplates(id, data);
    const { unlinkTemplates, unlinkTemplatesLength } = getState().unlinkTemplates;
    unlinkTemplates[index] = resp.data;
    dispatch({
      type: actions.GET_UNLINK_TEMPLATES,
      payload: {
        unlinkTemplates: unlinkTemplates,
        unlinkTemplatesLength: unlinkTemplatesLength,
      },
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORM_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_UNLINK_TEMPLATES,
      payload: false,
    });
  }
};

export const deleteUnlinkTemplates = (id, index) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_UNLINK_TEMPLATES,
      payload: true,
    });
    await UnlinkTemplatesServices.deleteUnlinkTemplates(id);
    const { unlinkTemplates, unlinkTemplatesLength } = getState().unlinkTemplates;
    unlinkTemplates.splice(index, 1);
    dispatch({
      type: actions.GET_UNLINK_TEMPLATES,
      payload: {
        unlinkTemplates: unlinkTemplates,
        unlinkTemplatesLength: unlinkTemplatesLength - 1,
      },
    });
    dispatch({
      type: actions.UNLINK_TEMPLATES_FAIL,
      payload: "",
    });
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.UNLINK_TEMPLATES_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_UNLINK_TEMPLATES,
      payload: false,
    });
  }
};
